import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthService from './AuthService';
import {getSessionStorage} from "../utils/helpers";

const SDACallback = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleAuth = async () => {
      try {
        await AuthService.handleCallback();
        navigate(AuthService.decrypt(getSessionStorage('SI_RD_P')) || '/dashboard'); // Redirect to home or dashboard
      } catch (error) {
        console.error('Authentication or token exchange failed', error);
        navigate('/error'); // Redirect to error page
      }
    };

    handleAuth();
  }, [navigate]);

  return <div>Loading...</div>;
};

export default SDACallback;
